import React from "react";
import TagsBaseComponent from "../bases/TagsBaseComponent/TagsBaseComponent"
export default function TagsPage() { return <TagsBaseComponent />; }
